import React, { useEffect, useState } from "react";
import style from "css/app.module.css";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { LoadingOutlined } from "@ant-design/icons";
import { Empty, Spin } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";

function Alrampop(props) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const gomypage = () => {
    navigate(process.env.REACT_APP_CLIENT_URL + "app/mypage/schedule", {
      state: { type: "card" },
    });

    alramoff();
  };

  const goHotdesking = () => {
    navigate(process.env.REACT_APP_CLIENT_URL + "app/hotdesking");

    alramoff();
  };

  let today = new Date();
  const DIFFDATE = (now, date) => {
    let nowTime = moment(now);
    let dateTime = moment(date);

    let diff = {
      month: moment.duration(nowTime.diff(dateTime)).months(),
      day: moment.duration(nowTime.diff(dateTime)).days(),
      hour: moment.duration(nowTime.diff(dateTime)).hours(),
      minute: moment.duration(nowTime.diff(dateTime)).minutes(),
    };

    if (diff.day < 1) {
      if (diff.hour < 1) {
        if (diff.minute < 1) {
          return <div>{t("ALARM.STATUS.JUST_NOW")}</div>;
        } else {
          // return <div>{diff.minute} 분 전</div>;
          return (
            <div>{t("ALARM.STATUS.MIN_BEFORE", { MIN: diff.minute })}</div>
          );
        }
      } else {
        return (
          <div>
            {/* {diff.hour}시간 {diff.minute}분 전 */}
            {t("ALARM.STATUS.HOUR_MIN_BEFORE", {
              HOUR: diff.hour,
              MIN: diff.minute,
            })}
          </div>
        );
      }
    } else {
      return (
        <div>
          {i18n.language === "en-US"
            ? dayjs(date).locale("en").format("dddd")
            : dayjs(date).locale("ko").format("dddd")}
        </div>
      );
    }
  };

  const changedLangConvert = (changedStr) => {
    console.log("changedlangconverter");
    if (i18n.language === "ko_KR") {
      return changedStr;
    } else if (i18n.language === "en-US") {
      let tmp = changedStr.split(",");
      console.log(tmp);
      for (let i = 0; i < tmp.length; i++) {
        tmp[i] = t("CHANGED." + tmp[i]);
      }

      console.log(tmp);
      return tmp.join(", ");
    }
  };

  const alramtype = (data) => {
    if (data.ALRAM_TYPE === "CD1301") {
      return (
        <div
          key={data.ALRAM_NUM}
          className={style.alramcontents + " cursor"}
          onClick={() => goHotdesking()}
        >
          <div className={style.alramcontent}>
            <div
              className={
                data.READ_YN === "Y" ? style.circle_grey : style.circle_blue
              }
            >
              <img
                alt=""
                src={
                  data.READ_YN === "Y"
                    ? process.env.REACT_APP_CLIENT_URL +
                      "img/alram/read_mail.png"
                    : process.env.REACT_APP_CLIENT_URL + "img/alram/b_mail.png"
                }
              />
            </div>
            <div className={style.content_text}>
              <div className={style.content_header}>
                <div
                  className={
                    data.READ_YN === "Y"
                      ? style.content_type_read
                      : style.content_type_b
                  }
                >
                  {t("ALARM.LABEL.HOTDESKING_SHARE")}
                </div>
                <div className={style.content_day}>
                  {DIFFDATE(today, data.INPUT_DT)}
                </div>
              </div>
              {/* <div className={style.content_title}>[{data.TITLE}]</div> */}
              <div className={style.content_title}>
                {t("ALARM.MESSAGE.HOTDESKING_SHARE", {
                  MEMBER_ID: data.MEMBER_ID,
                })}
              </div>
              <div className={style.content_sedt}>
                {i18n.language === "en-US"
                  ? dayjs(data.START_DATETIME)
                      .locale("en")
                      .format("MMMM DD, YYYY(ddd) HH:mm ~")
                  : dayjs(data.START_DATETIME)
                      .locale("ko")
                      .format("YYYY년 MM월 DD일 dddd HH:mm ~")}
                {dayjs(data.END_DATETIME).locale("ko").format(" HH:mm")}
              </div>
            </div>
            <div className={style.content_cancel}>
              <div
                className="cursor"
                onClick={(e) => {
                  e.stopPropagation();
                  removealram(data.ALRAM_NUM);
                }}
              >
                x
              </div>
            </div>
          </div>
          <div className={style.alramcontent_line} />
        </div>
      );
    } else if (data.ALRAM_TYPE === "CD1302") {
      return (
        <div key={data.ALRAM_NUM} className={style.alramcontents + " cursor"}>
          <div className={style.alramcontent}>
            <div
              className={
                data.READ_YN === "Y" ? style.circle_grey : style.circle_orange
              }
            >
              <img
                alt=""
                src={
                  data.READ_YN === "Y"
                    ? process.env.REACT_APP_CLIENT_URL +
                      "img/alram/read_edit.png"
                    : process.env.REACT_APP_CLIENT_URL + "img/alram/o_edit.png"
                }
              />
            </div>
            <div className={style.content_text}>
              <div className={style.content_header}>
                <div
                  className={
                    data.READ_YN === "Y"
                      ? style.content_type_read
                      : style.content_type_o
                  }
                >
                  {t("ALARM.LABEL.SCHEDULE_CHANGED")}
                </div>
                <div className={style.content_day}>
                  {DIFFDATE(today, data.INPUT_DT)}
                </div>
              </div>
              <div className={style.content_title}>[{data.TITLE}]</div>
              <div className={style.content_title}>
                {/* {"  " + data.CONTENTS}(이)가 수정되었습니다. */}
                {t("ALARM.MESSAGE.SCHEDULE_CHANGED", {
                  CONTENT: changedLangConvert(data.CONTENTS),
                })}
              </div>
            </div>
            <div className={style.content_cancel}>
              <div
                className="cursor"
                onClick={(e) => {
                  e.stopPropagation();
                  removealram(data.ALRAM_NUM);
                }}
              >
                x
              </div>
            </div>
          </div>
          <div className={style.alramcontent_line} />
        </div>
      );
    } else if (data.ALRAM_TYPE === "CD1303") {
      return (
        <div key={data.ALRAM_NUM} className={style.alramcontents + " cursor"}>
          <div className={style.alramcontent}>
            <div
              className={
                data.READ_YN === "Y" ? style.circle_grey : style.circle_red
              }
            >
              <img
                alt=""
                src={
                  data.READ_YN === "Y"
                    ? process.env.REACT_APP_CLIENT_URL +
                      "img/alram/read_cross.png"
                    : process.env.REACT_APP_CLIENT_URL + "img/alram/r_cross.png"
                }
              />
            </div>
            <div className={style.content_text}>
              <div className={style.content_header}>
                <div
                  className={
                    data.READ_YN === "Y"
                      ? style.content_type_read
                      : style.content_type_r
                  }
                >
                  {t("ALARM.LABEL.SCHEDULE_CANCELED")}
                </div>
                <div className={style.content_day}>
                  {DIFFDATE(today, data.INPUT_DT)}
                </div>
              </div>
              <div className={style.content_title}>[{data.TITLE}]</div>
              <div className={style.content_sedt}>
                {i18n.language === "en-US"
                  ? dayjs(data.START_DATETIME)
                      .locale("en")
                      .format("MMMM DD, YYYY(ddd) HH:mm ~")
                  : dayjs(data.START_DATETIME)
                      .locale("ko")
                      .format("YYYY년 MM월 DD일 dddd HH:mm ~")}
                {dayjs(data.END_DATETIME).locale("ko").format(" HH:mm")}
              </div>
            </div>
            <div className={style.content_cancel}>
              <div
                className="cursor"
                onClick={(e) => {
                  e.stopPropagation();
                  removealram(data.ALRAM_NUM);
                }}
              >
                x
              </div>
            </div>
          </div>
          <div className={style.alramcontent_line} />
        </div>
      );
    } else if (data.ALRAM_TYPE === "CD1304") {
      return (
        <div key={data.ALRAM_NUM} className={style.alramcontents + " cursor"}>
          <div className={style.alramcontent}>
            <div
              className={
                data.READ_YN === "Y" ? style.circle_grey : style.circle_green
              }
            >
              <img
                alt=""
                src={
                  data.READ_YN === "Y"
                    ? process.env.REACT_APP_CLIENT_URL +
                      "img/alram/read_bell.png"
                    : process.env.REACT_APP_CLIENT_URL + "img/alram/g_bell.png"
                }
              />
            </div>
            <div className={style.content_text}>
              <div className={style.content_header}>
                <div
                  className={
                    data.READ_YN === "Y"
                      ? style.content_type_read
                      : style.content_type_g
                  }
                >
                  {t("ALARM.STATUS.5MIN_BEFORE_MEETING")}
                </div>
                <div className={style.content_day}>
                  {DIFFDATE(today, data.INPUT_DT)}
                </div>
              </div>
              <div className={style.content_title}>[{data.TITLE}]</div>
            </div>
            <div className={style.content_cancel}>
              <div
                className="cursor"
                onClick={(e) => {
                  e.stopPropagation();
                  removealram(data.ALRAM_NUM);
                }}
              >
                x
              </div>
            </div>
          </div>
          <div className={style.alramcontent_line} />
        </div>
      );
    } else if (data.ALRAM_TYPE === "CD1305") {
      return (
        <div key={data.ALRAM_NUM} className={style.alramcontents + " cursor"}>
          <div className={style.alramcontent}>
            <div
              className={
                data.READ_YN === "Y" ? style.circle_grey : style.circle_red
              }
            >
              <img
                alt=""
                src={
                  data.READ_YN === "Y"
                    ? process.env.REACT_APP_CLIENT_URL +
                      "img/alram/read_cross.png"
                    : process.env.REACT_APP_CLIENT_URL + "img/alram/r_cross.png"
                }
              />
            </div>
            <div className={style.content_text}>
              <div className={style.content_header}>
                <div
                  className={
                    data.READ_YN === "Y"
                      ? style.content_type_read
                      : style.content_type_r
                  }
                >
                  {t("ALARM.LABEL.EXCLUDED")}
                </div>
                <div className={style.content_day}>
                  {DIFFDATE(today, data.INPUT_DT)}
                </div>
              </div>
              <div className={style.content_title}>[{data.TITLE}]</div>
              <div className={style.content_sedt}>
                {i18n.language === "en-US"
                  ? dayjs(data.START_DATETIME)
                      .locale("en")
                      .format("MMMM DD, YYYY(ddd) HH:mm ~")
                  : dayjs(data.START_DATETIME)
                      .locale("ko")
                      .format("YYYY년 MM월 DD일 dddd HH:mm ~")}
                {dayjs(data.END_DATETIME).locale("ko").format(" HH:mm")}
              </div>
            </div>
            <div className={style.content_cancel}>
              <div
                className="cursor"
                onClick={(e) => {
                  e.stopPropagation();
                  removealram(data.ALRAM_NUM);
                }}
              >
                x
              </div>
            </div>
          </div>
          <div className={style.alramcontent_line} />
        </div>
      );
    }
  };

  const removealram = (data) => {
    let config = {
      params: {
        ALRAM_NUM: data,
      },
    };
    axios.get("/alram/deletealram", config).then((res) => {
      if (res.status === 200) {
        const newdata = ghostlist.filter((datas) => datas.ALRAM_NUM !== data);
        setghostlist(newdata);
      }
    });
  };
  const alramoff = () => {
    props.alrammoff();
  };
  const [loading, setloading] = useState(false);
  const [alramlist, setalramlist] = useState([]);
  const [ghostlist, setghostlist] = useState([]);
  const payload = useSelector((state) => state.user);
  const [run, setrun] = useState(true);
  useEffect(() => {
    if (run) {
      setloading(true);
      let config = {
        params: {
          TARGET_USER: payload.id,
        },
      };
      axios
        .get("/alram/getalramlist", config)
        .then((res) => {
          if (res.status === 200) {
            setalramlist(res.data);
            setghostlist(res.data);
          }
        })
        .finally(
          setrun(false),
          axios
            .get("/alram/readalram", config)
            .then((res) => {
              if (res.status === 200) {
              }
            })
            .finally(() => {
              setloading(false);
              setrun(false);
            })
        );
    }
  }, [run]);

  return (
    <div className={props.main ? style.alramset_main : style.alramset}>
      <div className={style.alrampop}>
        {/* <div>삼각형</div> */}

        <div className={style.alramheader}>
          <div className={style.alramheader_txt}>{t("ALARM.TITLE")}</div>
          <div className="cursor">
            <img
              alt=""
              src={process.env.REACT_APP_CLIENT_URL + "img/alram/sync.png"}
              onClick={() => setrun(true)}
            />
          </div>
        </div>

        <div className={style.alrambody + " " + style.scrollbar}>
          {loading ? (
            <div className={style.alramspin}>
              <Spin size="large" />
            </div>
          ) : ghostlist.length > 0 ? (
            ghostlist.map((data, index) => alramtype(data))
          ) : (
            <div>
              <div className={style.alramspin}>
                <Empty description={t("MESSAGE.NO_DATA")} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Alrampop;
